import { ACTIVATE } from '../actions/types';

const initialState = {
  isError: false,
  isLoading: false,
  isSuccess: false,
  data: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIVATE.START:
      return {
        ...state,
        isLoading: true,
        data: null,
      };
    case ACTIVATE.ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        data: null,
        error: action.payload.response,
      };
    case ACTIVATE.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isSuccess: true,
        data: action.payload,
        error: null,
      };
    default:
      return state;
  }
};
